import React from 'react'

import {
  loginPath,
  signupPath,
  signupEmailFormPath,
} from '$extensionSrc/consts/urlConsts'

export default function LoginSignupLink() {
  const currentURL = new URL(window.location.href)
  let currentPath = currentURL.pathname
  if (!currentPath.endsWith('/')) {
    currentPath = `${currentPath}/`
  }

  switch (currentPath) {
    case loginPath:
      return (
        <div className="LoginSignupLink body2">
          Don't have an account yet?{' '}
          <a className="link2" href={signupPath}>
            Sign up
          </a>
        </div>
      )
    case signupEmailFormPath:
    case signupPath:
      return (
        <div className="LoginSignupLink body2">
          Already have an account?{' '}
          <a className="link2" href={loginPath}>
            Log in
          </a>
        </div>
      )
    default:
      return null
  }
}
